import { useAnalytics } from './useAnalytics';
import { IErrorMessageParam, IRNftParams } from './useEventsParams';

export interface IPackageParams {
  packageId: string; // Package ID
  packageName?: string;
  fnftsAmount: number; // total_shares
  nftIds?: string; // Comma separated asset_token_ids
  fnftsAmounts?: string; // Comma separated amounts
  amountRmv?: number;
  transactionHash?: string;
}

enum PackageEventName {
  Buy = 'buy_package',
  BuySuccess = 'buy_package_success',
  BuyError = 'buy_package_error',
}

export const usePackageEvents = () => {
  const { sendEvent } = useAnalytics();

  // Internal function to send package events
  const sendPackageBuyEventInternal = (params: IPackageParams) => {
    sendEvent(PackageEventName.Buy, params);
  };

  const sendPackageBuySuccessEventInternal = (params: IPackageParams) => {
    sendEvent(PackageEventName.BuySuccess, params);
  };

  const sendPackageBuyErrorEventInternal = (params: IPackageParams & IErrorMessageParam) => {
    sendEvent(PackageEventName.BuyError, params);
  };

  // Adapter functions to convert from IRNftParams (BuyParams) to IPackageParams
  const sendPackageBuyEvent = (params: IRNftParams) => {
    sendPackageBuyEventInternal(params as unknown as IPackageParams);
  };

  const sendPackageBuySuccessEvent = (params: IRNftParams) => {
    sendPackageBuySuccessEventInternal(params as unknown as IPackageParams);
  };

  const sendPackageBuyErrorEvent = (params: IRNftParams & IErrorMessageParam) => {
    sendPackageBuyErrorEventInternal(params as unknown as IPackageParams & IErrorMessageParam);
  };

  return {
    sendBuyEvent: sendPackageBuyEvent,
    sendBuySuccessEvent: sendPackageBuySuccessEvent,
    sendBuyErrorEvent: sendPackageBuyErrorEvent,
  };
};
